/*
 * Pure lightweight vanilla script so we can't use an ES6 pattern for this.
 * Requires "./src/vendor/vanilla-cookieconsent/dist/cookieconsent.js" to be bundled together with this file.
 * https://github.com/orestbida/cookieconsent
 * https://orestbida.com/demo-projects/cookieconsent/
 * This implementation made by Furillo Agency AB.
 */

window.addEventListener('DOMContentLoaded', function () {
    
    var ensureTagManagerCookieConsent = function (categories) {

        console.debug('CookieConsent', 'Awaiting Tag Manager to load...');

        var mtmTrackerTries = 0;
        var ensureMtmTracker = function () {
            if (!window._mtm && mtmTrackerTries < 40) {
                setTimeout(ensureMtmTracker, 250);
                mtmTrackerTries++;
                return;
            }
            return;
        };

        ensureMtmTracker();
        if (!window._mtm) {
            console.debug('CookieConsent', 'No Tag Manager could be resolved, skipping.');
            return;
        }          

        var event = { 'event': 'cookieConsentDecision', 'cookieConsentCategories': categories };

        console.debug('CookieConsent', 'Push event to Tag Manager (window._mtm.push(' + JSON.stringify(event) + ');)');               
        window._mtm.push(event);
    };

    console.debug('CookieConsent', 'Initiating...');

    // Add custom theme to body
    document.querySelector('body').classList.add('cookieconsent-theme');

    // obtain cookieconsent plugin
    var cookieconsent = initCookieConsent();

    fetch('/api/sharedfunctions/cookieconsentconfig/get?host=' + window.location.host).then(function (config) {
        return config.json();
    }).then(function (json) {

        console.debug('CookieConsent', 'Configuration loaded, run (display if no prior consent).');

        cookieconsent.run({
            autorun: true,
            auto_language: 'document',
            autoclear_cookies: true,
            page_scripts: true,
            hide_from_bots: true,
            gui_options: {
                consent_modal: {
                    layout: 'cloud',               // box/cloud/bar
                    position: 'bottom center',     // bottom/middle/top + left/right/center
                    transition: 'slide',           // zoom/slide
                    swap_buttons: false            // enable to invert buttons
                },
                settings_modal: {
                    layout: 'box',                 // box/bar
                    // position: 'left',           // left/right
                    transition: 'slide'            // zoom/slide
                }
            },

            onFirstAction: function (user_preferences, cookie) {
                // Do nothing
            },
            onAccept: function (cookie) {
                console.debug('CookieConsent', 'Consent given for ' + JSON.stringify(cookie.categories) + ', enable local scripts (if any).');
                ensureTagManagerCookieConsent(cookie.categories);
            },
            onChange: function (cookie, changed_preferences) {
                console.debug('CookieConsent', 'Changes made, consent given for ' + JSON.stringify(cookie.categories) + ', enable local scripts (if any).');
                ensureTagManagerCookieConsent(cookie.categories);
            },
            languages: json
        });


    }).catch(function (err) {
        console.warn('CookieConsent', 'Something went wrong when initiating Cookie Consent!', err);
    });
});